<div class="header">
  <h3>{{'ABB-DASHBOARD.TITLE' | translate}}</h3>
</div>

<div class="box-filter position-relative z-2">
  <app-filter-header [loading]="loading" (search)="search()" (clear)="clear()"></app-filter-header>

  <div class="row row-eq-height">
<!--disable feature-->
<!--    <div class="col-md-4 pb-3">-->
<!--      <ng-select-->
<!--        class="custom"-->
<!--        id="sellerName"-->
<!--        [items]="sellerNames"-->
<!--        placeholder="{{'FILTER.COMPANY'|translate}}"-->
<!--        [(ngModel)]="searchSeller"-->
<!--        [ngClass]="{'selected': searchSeller || searchingSeller}"-->
<!--        (focus)="searchingSeller = true"-->
<!--        (blur)="searchingSeller = false">-->
<!--      </ng-select>-->
<!--      <label-->
<!--        class="select-label"-->
<!--        *ngIf="searchSeller || searchingSeller"-->
<!--        for="sellerName">{{ 'FILTER.COMPANY'|translate }}-->
<!--      </label>-->
<!--    </div>-->
    <div class="col-md-6 pb-3">
      <ng-select
        class="custom"
        id="branchCode"
        [items]="branchCode"
        bindLabel="full_name"
        bindValue="branch_code"
        placeholder="{{ 'FILTER.BRANCH' | translate }}"
        [(ngModel)]="searchBranch"
        [ngClass]="{'selected': searchBranch || searchingBranch}"
        (focus)="searchingBranch = true"
        (blur)="searchingBranch = false">
      </ng-select>
      <label
        class="select-label"
        *ngIf="searchBranch || searchingBranch"
        for="branchCode">{{'FILTER.BRANCH'|translate}}
      </label>
    </div>
    <div class="col-md-6 pb-3">
      <ng-select
        class="custom"
        id="outlet"
        [items]="outlet"
        bindLabel="name"
        bindValue="id"
        placeholder="{{'FILTER.OUTLET'|translate}}"
        [(ngModel)]="searchOutlet"
        [ngClass]="{'selected': searchOutlet || searchingOutlet}"
        (focus)="searchingOutlet = true"
        (blur)="searchingOutlet = false">
      </ng-select>
      <label
        class="select-label"
        *ngIf="searchOutlet || searchingOutlet"
        for="outlet">{{'FILTER.OUTLET'|translate}}</label>
    </div>
    <div class="col-md-6">
      <div class="form-label-group">
        <input class="form-control"
            type="text"
            id="abb-no"
            [(ngModel)]="abbNo"
            placeholder="{{'FILTER.ABB-NO' | translate}}">
        <label for="abb-no">{{'FILTER.ABB-NO' | translate}}</label>
      </div>
    </div>
    <div class="col-md-6">
      <div class="dropdown" #dd="ngbDropdown" ngbDropdown placement="bottom-right" autoClose="outside">
        <div class="form-label-group">
          <input #ddi
              class="form-control"
              type="text"
              id="calendarDropdown"
              [value]="dateRange"
              ngbDropdownToggle
              placeholder="{{'FILTER.DATE-OF-ISSUE' | translate}}"
              readonly>
          <label for="calendarDropdown">{{'FILTER.DATE-OF-ISSUE' | translate}}</label>
          <div class="calendar-trigger" (click)="$event.stopPropagation(); dd.toggle()">
            <span class="far fa-calendar"></span>
          </div>
        </div>
        <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="calendarDropdown">
          <div class="row">
            <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.SINCE' | translate}}</div>
            <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.UNTIL' | translate}}</div>
          </div>
          <div (click)="stopPropagation($event)">
            <p-calendar [(ngModel)]="startDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [maxDate]="maxDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMinDate()" [inline]="true"
                        [locale]="calendarLocale"></p-calendar>
            <p-calendar [(ngModel)]="endDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [minDate]="minDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMaxDate(); dd.close()" [inline]="true"
                        [locale]="calendarLocale"></p-calendar>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="box-parent position-relative z-1">
  <app-custom-pagination [(currentPage)]="currentPage"
      [(itemsPerPage)]="itemsPerPage"
      [totalItems]="totalItems"
      [maxSize]="5"
      (pageChange)="pageChanged()"
      (optionChange)="optionChanged()"
      *ngIf="loading === false && totalItems !== 0">
  </app-custom-pagination>

  <div class="row m-t-20" *ngIf="loading">
    <div class="col-12 text-center">
      <i class="fa fa-spinner fa-spin fa-lg"></i>
    </div>
  </div>

  <div class="row m-t-20" *ngIf="!loading && totalItems === 0">
    <div class="col-12 text-center">
      <h5>{{'COMMON.DATA-NOT-FOUND' | translate}}</h5>
    </div>
  </div>

  <div class="m-t-20 text-center" *ngIf="!loading && totalItems !== 0">
      <p-table tableStyleClass="table"
          [value]="tableData"
          [autoLayout]="true">
        <ng-template pTemplate="header">
          <tr>
            <th>{{'COMMON.TABLE.ORDER' | translate}}</th>
            <th>{{'TABLE.ISSUE-DATE' | translate}}</th>
            <th>{{'TABLE.ABB-NO' | translate}}</th>
            <th>{{'TABLE.ETAX-TIV' | translate}}</th>
            <th>{{'TABLE.BRANCH-CODE' | translate}}</th>
            <th>{{'TABLE.OUTLET' | translate}}</th>
            <th>{{'TABLE.SALES' | translate}} Vat</th>
            <th>{{'TABLE.VAT' | translate}}</th>
            <th>{{'TABLE.SALES' | translate}} NON-Vat</th>
            <th>{{'TABLE.TOTAL-PAYMENT' | translate}}</th>
            <th>{{'TABLE.ISSUE-DOCS' | translate}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data let-index="rowIndex">
          <tr>
            <td>{{index + 1 + ((currentPage - 1) * itemsPerPage)}}</td>
            <td>{{data.issue_dt | date:"dd/MM/yyyy"}}</td>
            <td>{{data.abb_no}}</td>
            <td>{{data.etax_invoice_number || '-'}}</td>
            <td>{{data.branch_code || '-'}}</td>
            <td>{{data.outlet || '-'}}</td>
            <td>{{data.vat_basis_amount | number:'1.2-2'}}</td>
            <td>{{data.vat_amount | number:'1.2-2'}}</td>
            <td>{{data.non_vat_amount | number:'1.2-2'}}</td>
            <td>{{data.total_payment | number:'1.2-2'}}</td>
            <td>
              <i class="fa fa-chevron-right pointer"
                  (click)="gotoDocumentIssue(data)"
                  [ngClass]="{'disabled': data.etax_invoice_number}"></i>
            </td>
          </tr>
        </ng-template>
      </p-table>
  </div>
</div>


// WEBPACK FOOTER //
// /opt/app/src/app/features/abb-dashboard/abb-dashboard.component.html